
import { Component, Vue } from 'vue-property-decorator';

import { sharedState } from '../../../../framework/state';
import { postResource } from '../../../../framework/client/resource';
import TextField from '../../../../framework/fields/TextField.vue';
import SelectField from '../../../../framework/fields/SelectField.vue';
import { AccountType } from '../../../../../common/application/model/enums/AccountType';
import { Account } from '../../../../../common/application/model/Account';
import { getEnumerationOptions } from '../../../../framework/service/options';
import SwitchField from '../../../../framework/fields/SwitchField.vue';
import { getCustomerOptions } from '../../../service/application_options_service';
import PercentageField from '../../../../framework/fields/PercentageField.vue';
import { ValidationObserver } from 'vee-validate';
import { ApplicationResource } from '../../../../../common/application/enumeration/ApplicationResource';

@Component({
    components: { PercentageField, SwitchField, SelectField, TextField, ValidationObserver },
})
export default class AddAccount extends Vue {
    // Constants
    readonly resourceType = ApplicationResource.ACCOUNT;

    // Properties

    // State
    shared = sharedState;
    local = {
        row: {
            active: false,
        } as Account,
        accountTypeOptions: [] as { id: string | undefined; label: string }[],
        customerOptions: [] as { id: string | undefined; label: string }[],
    };

    // Functions
    async mounted() {
        this.local.accountTypeOptions = getEnumerationOptions('AccountType', Object.keys(AccountType), this);
        this.local.customerOptions = await getCustomerOptions();
    }

    async add() {
        await postResource<Account>(this.resourceType, this.local.row);
        this.back();
    }

    back() {
        this.$router.go(-1);
    }
}
